import {AppShell, Group, Header, Text, useMantineColorScheme} from "@mantine/core";
import {Outlet} from "react-router-dom";
import React from "react";
import {APPLICATION_DISPLAY_NAME} from "../../settings";
import AppLogo from "../../assets/logo.png";

function Logo () {
    return <img alt="logo" src={AppLogo} height="50%"/>;
}

function Auth() {
    const {colorScheme} = useMantineColorScheme();
    return (
        <AppShell
            padding={0}
            fixed
            header={
                <Header height={60}>
                    <Group sx={{height: '100%'}} px={20} position="apart">
                        <Logo/>
                    </Group>
                </Header>
            }
            styles={(theme) => ({
                main: {
                    backgroundColor:
                        theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.colors.gray[0],
                },
            })}
        >
            <Outlet/>
        </AppShell>

    )

}

export default Auth;